import { render, staticRenderFns } from "./PerfiosActivity.vue?vue&type=template&id=1fea40c6&scoped=true&"
import script from "./PerfiosActivity.vue?vue&type=script&lang=js&"
export * from "./PerfiosActivity.vue?vue&type=script&lang=js&"
import style0 from "../../../assets/style/base.css?vue&type=style&index=0&id=1fea40c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea40c6",
  null
  
)

export default component.exports